import React from 'react';

import {handleNewLabel} from '/component/base/NewLabel/NewLabel.util';
import Text from '/component/base/Text';
import {Reports} from '/constant/TestIDs';
import {useTranslation} from '/provider/TranslationProvider';
import testProperties from '/util/testing/testProperties';

import {styles} from './NewLabel.style';

interface Item {
  isFrontLine: boolean;
  isNew: boolean;
}

interface NewLabelProps {
  item: Item | null;
}

export const NewLabel: React.FC<NewLabelProps> = ({item = null}) => {
  const {tt} = useTranslation('report.record.newLabel');
  const showNewLabel = item.isNew || handleNewLabel({item});
  return showNewLabel ? (
    <Text
      variant="caption"
      style={styles.newLabel}
      {...testProperties(Reports.reportNewTag)}>
      {tt('newLabel', 'New')}
    </Text>
  ) : null;
};
